import React from "react";

const PlanButtons = () => {
  return (
    <div className="row">
      <div className="col-12 pb-5">
        <h2 class="ss-title text-primary pb-2">
          <strong>
            <strong>Plan</strong>
          </strong>
        </h2>
        <div class="col-6 pb-5 mx-0 px-0 btn-group" style="width:100%">
          <button style="width:33.3%" type="button" value="Free" name="plan">
            Free
          </button>
          <button style="width:33.3%" type="button" value="Level 1" name="plan">
            Level 1
          </button>
          <button style="width:33.3%" type="button" value="Level 2" name="plan">
            Level 2
          </button>
        </div>
      </div>
    </div>
  );
};
export default PlanButtons;



// WEBPACK FOOTER //
// ./resources/assets/js/app/PlanButtons/index.js